import React from "react";
const HorizontalLine = ({ ...r }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...r}
    >
      <path fill="#CCC" d="M4 11.5h16v1H4z"></path>
    </svg>
  );
};

export default HorizontalLine;
